import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { CommonService } from "../../services/common.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-proofcard-image-viewer",
  templateUrl: "./proofcard-image-viewer.component.html",
  styleUrls: ["./proofcard-image-viewer.component.css"],
})
export class ProofcardImageViewerComponent implements OnInit {
  selectedImage: any;
  selectedImageCode:any;

  @Input() title: string;
  @Input() message: string;
  @Input() images: any[];
  @Input() selectedImages: any[];
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() isShowClickToSelect: boolean = false;
  @Output() clickToSelectEvent = new EventEmitter<any>();
  currentId: any = 0;


  constructor(
    private activeModal: NgbActiveModal,
    public _sanitize: DomSanitizer,
    private activeRoute: ActivatedRoute,
    public _DomSanitizationService: DomSanitizer,
    private commonServ: CommonService,
    private http: HttpClient
  ) {}

  getQuantityOfCurrentImageCode() {
    console.log(this.selectedImages);
    let slides = this.selectedImages;
    let slide = this.images[this.currentId];
    let currentSelectedCodes = slides.filter(
      (el) => el.image_code == slide.image_code
    );
    console.log('currentSelectedCodes', currentSelectedCodes);
    return currentSelectedCodes.length;
  }

  clickToSelect() {
    this.clickToSelectEvent.emit({
      action: 'click_to_select',
      index: this.currentId
    });
  }
  onPrevious() {
    this.currentId = this.currentId - 1;
    this.selectedImage = this.images[this.currentId].image;
    this.selectedImageCode = this.images[this.currentId].image_code;
  }
  onNext() {
    this.currentId = this.currentId + 1;
    this.selectedImage = this.images[this.currentId].image;
    this.selectedImageCode = this.images[this.currentId].image_code;
  }

  ngOnInit() {
    this.selectedImage = this.images[this.currentId].image;
    this.selectedImageCode = this.images[this.currentId].image_code;
    console.log("images", this.images);
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  saveLike() {
    let image = this.images[this.currentId];
    let newRating = image.rating == 1 ? 1 : 0;
    console.log("newRating", newRating, image);
    let userInfo = JSON.parse(sessionStorage.getItem("account-user"));
    this.images[this.currentId].rating = newRating;
    let pfId = Number(sessionStorage.getItem("proofcard_Id"));
    let body = {
      proofcard_id: pfId,
      register_user_id: userInfo.id,
      image_name: image.image_name,
      rating: newRating,
    };
    const url = environment.URL + "/proofcard/rating";
    this.http.post(url, body).subscribe(
      (res: any) => {
        console.log(res);
      },
      (err) => console.error(err)
    );
  }
}
